import { makeAutoObservable } from "mobx";
import { DateButtons } from "../enums/DateButtons";
import { ITag } from "../interfaces/ITag";
import { DateHelper } from "../helpers/DateHelper";
import ITagWithRelated from "./Tags";
import { ViewComponents } from "../components/pages/list/EventPreviewManagmentPanel/EventViewManagmentPanel";
import { eventsStore } from "./Events";
import { FilterDates, filterDatesGl } from "./FilterDates";
import { adminDateFilterGl } from "./AdminDateFilter";
import { filterTagsGl } from "./FilterTags";
export enum menuPages {
  "main",
  "likes",
  "about",
}

export class Settings {
  public dateFromSec: number = 0;
  public dateToSec: number = 0;
  public currentPage: number = 0;
  public static chunkLength: number = 3;
  public hasMore: boolean = true;
  public scrollReload: boolean = true;
  public scrollKeyCounter = 0;
  public showOnlyUnique: boolean = true;
  public currentDayFilter: DateButtons = DateButtons.today;
  public selectedTag: ITag = {} as ITag;
  public selectedListOfEvents: ITagWithRelated["related"] = [];
  public showMenuFilter: boolean = true;
  public isTgScrolWorking = true;
  public test = "test";
  public currentComponentViewState: ViewComponents = ViewComponents.textOverImg;
  public showFreeEvents = false;
  public searchQuery = "";

  public numberOfFreeEvents = 0;

  public scrollElementHeight = 0;

  public currentRoute: menuPages = menuPages.main;

  /**
   * Нужно ли объяснять пользователю о работе категорий
   */
  public informed = null;

  constructor() {
    makeAutoObservable(this);
  }

  public changeCurrentViewState(newValue: ViewComponents) {
    this.currentComponentViewState = newValue;
  }

  /**
   * Очистить все, перазгрузиь пагинацию.
   */
  public clearAllFilters() {
    eventsStore.listOfPreviewEvents = [];
    settingsGl.scrollReload = !settingsGl.scrollReload;
    settingsGl.scrollKeyCounter++;
    settingsGl.currentPage = 0;
    filterDatesGl.listOfSelecedDates = [];
    settingsGl.showFreeEvents = false;
    settingsGl.currentPage = 0;
    settingsGl.hasMore = true;
    settingsGl.searchQuery = "";
  }

  /**
   * Перезагузить с текущими настройками
   */
  public async reloadEvents() {
    eventsStore.listOfPreviewEvents = [];
    settingsGl.scrollReload = !settingsGl.scrollReload;
    settingsGl.currentPage = 0;
    await eventsStore.getListOfPreviewEvents(
      111,
      1111,
      filterTagsGl.listOfSelectedTags.map((el) => el.id),
      settingsGl.currentPage,
      Settings.chunkLength,
      settingsGl.showOnlyUnique,
      settingsGl.currentDayFilter,
      {},
      filterDatesGl.listOfSelecedDates,
      Array.from(adminDateFilterGl.listOfSelectedDates)
    );
  }

  /**
   * Получить временное интервал(от и до)
   * @param dayFilter
   */
  public static getTimeInterval(dayFilter: DateButtons): {
    startSec: number;
    finishSec: number;
    dateFromStr?: string;
    dateToStr?: string;
  } {
    switch (dayFilter) {
      case DateButtons.today:
        const todaySec = Math.floor(Date.now() / 1000);
        return {
          startSec: todaySec,
          finishSec: todaySec,
        };
      case DateButtons.tomorrow:
        const tomorrowSec = Math.floor(Date.now() / 1000) + 24 * 60 * 60;
        return {
          startSec: tomorrowSec,
          finishSec: tomorrowSec,
        };
      case DateButtons.week:
        const { dateFromSec, dateToSec, dateFromStr, dateToStr } =
          DateHelper.getWeekPeriodSec();

        return {
          startSec: dateFromSec,
          finishSec: dateToSec,
          dateFromStr,
          dateToStr,
        };

      case DateButtons.all:
        return {
          startSec: 0,
          finishSec: 0,
        };
    }
  }
}
export const settingsGl = new Settings();
